module.exports = __webpack_public_path__ + "static/img/kh-3.bcfe52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-3.png
// module id = mnjw
// module chunks = 5